/*
  TMS search helpers (new file).

  1. TMSSearch.rewrite(q): maps common misspellings, Arabic and Arabizi
     (Franco) searches to the English words our product titles use, so
     "wey", "كرياتين" or "7ari2 dhoun" find whey, creatine and fat burners.
     Used by predictive-search.js before it calls the Predictive Search API,
     and on submit of any search form (the original words travel along as
     `oq` so the results page can say "Showing results for ...").
  2. TMSSearch.didYouMean(q): up to 3 spelling suggestions for the
     no-results states (dropdown and /search page).
  3. Search page helpers: the "Showing results for" note, the "Did you mean"
     links, and a one-time retry with the corrected term when a search that
     came in by link (no `oq`) has zero results.

  The alias table is plain JSON between the ALIASES markers so it can be
  tested outside the browser (proposals/search-2026-10-03/tools/search_test.py).
  Keys are in normalized form: lower case, Arabic letters unified (أ إ آ to ا,
  ى to ي, ة to ه), no diacritics, single spaces.
  Once the Search & Discovery synonym groups are in place this file still
  helps with whole-phrase Arabic and Arabizi queries, but nothing breaks if it
  is removed.
*/
(function () {
  if (window.TMSSearch) return;

  var ALIASES = /*ALIASES_START*/{
    "wey": "whey", "whay": "whey", "wheyy": "whey", "way protein": "whey protein", "wey protein": "whey protein",
    "protien": "protein", "protin": "protein", "protine": "protein", "proteine": "protein", "protean": "protein",
    "brotein": "protein", "brotin": "protein", "brotien": "protein", "prtein": "protein",
    "creatin": "creatine", "kreatin": "creatine", "kreatine": "creatine", "creatien": "creatine", "cretine": "creatine",
    "creatina": "creatine", "kriatin": "creatine", "kreyatin": "creatine", "krayatin": "creatine", "keratin": "creatine",
    "bcca": "bcaa", "bca": "bcaa", "bcaas": "bcaa", "bcaa's": "bcaa", "bcca's": "bcaa",
    "glutamin": "glutamine", "glutamen": "glutamine", "glotamine": "glutamine",
    "colagen": "collagen", "collagene": "collagen", "kolagen": "collagen", "collegen": "collagen", "colagene": "collagen",
    "omega3": "omega 3", "omega-3": "omega 3", "omga 3": "omega 3", "fishoil": "fish oil",
    "multivitamine": "multivitamin", "multi vitamin": "multivitamin", "multi vitamins": "multivitamin",
    "vitamine": "vitamin", "vitamen": "vitamin", "fitamin": "vitamin", "fitamins": "vitamin", "fitamine": "vitamin",
    "pre workot": "pre workout", "preworkot": "pre workout", "pre work out": "pre workout", "pre-workout": "pre workout",
    "pre wrkout": "pre workout", "preworkout": "pre workout", "pre": "pre workout",
    "geiner": "gainer", "gainr": "gainer", "mass geiner": "mass gainer", "weight gain": "mass gainer",
    "weight gainer": "mass gainer", "isolat": "isolate", "isolate whey": "whey isolate",
    "fatburner": "fat burner", "fat burners": "fat burner", "fat burn": "fat burner",
    "testo": "testosterone", "testosteron": "testosterone", "test booster": "testosterone",
    "on": "optimum nutrition", "on whey": "optimum nutrition whey",
    "gold standart": "gold standard", "muscle tech": "muscletech", "nitrotech": "nitro tech",
    "rule one": "rule1", "rule 1": "rule1", "ruleone": "rule1", "r1": "rule1", "r 1": "rule1", "iso 100": "iso100", "lipo6": "lipo 6",
    "biotech usa": "biotechusa", "bio tech": "biotechusa", "levrone": "kevin levrone",
    "zyedet wazn": "mass gainer", "zyedet wazen": "mass gainer", "ziyadet wazn": "mass gainer", "ziyadet wazen": "mass gainer",
    "7ari2 dhoun": "fat burner", "7ari2 dhun": "fat burner", "7arek dhoun": "fat burner", "7ari2 l dhoun": "fat burner",
    "بروتين": "protein", "البروتين": "protein", "بروتين واي": "whey protein", "واي بروتين": "whey protein", "واي": "whey",
    "كرياتين": "creatine", "الكرياتين": "creatine", "كرياتين مونوهيدرات": "creatine monohydrate", "كيراتين": "creatine",
    "فيتامين": "vitamin", "فيتامينات": "vitamin", "الفيتامينات": "vitamin", "ملتي فيتامين": "multivitamin",
    "اوميغا": "omega 3", "اوميغا 3": "omega 3", "اوميجا": "omega 3", "اوميجا 3": "omega 3", "زيت السمك": "fish oil", "زيت سمك": "fish oil",
    "حارق دهون": "fat burner", "حارق الدهون": "fat burner", "حرق الدهون": "fat burner", "حرق دهون": "fat burner", "تنحيف": "weight loss",
    "زياده الوزن": "mass gainer", "زياده وزن": "mass gainer", "تضخيم": "mass gainer", "ماس جينر": "mass gainer", "جينر": "gainer",
    "كولاجين": "collagen", "الكولاجين": "collagen", "كولاجن": "collagen",
    "جلوتامين": "glutamine", "غلوتامين": "glutamine", "امينو": "amino", "احماض امينيه": "amino",
    "بي سي اي اي": "bcaa", "قبل التمرين": "pre workout", "بري وركاوت": "pre workout",
    "تستوستيرون": "testosterone", "هرمون الذكوره": "testosterone", "كازين": "casein", "ايزوليت": "isolate",
    "زنك": "zinc", "مغنيسيوم": "magnesium", "اوبتيموم": "optimum nutrition", "اوبتيموم نيوتريشن": "optimum nutrition",
    "ماسل تك": "muscletech", "دايماتايز": "dymatize", "سي 4": "c4"
  }/*ALIASES_END*/;

  // Words we offer as "Did you mean" when nothing matches.
  var VOCAB = [
    'whey', 'protein', 'whey isolate', 'creatine', 'mass gainer', 'gainer', 'fat burner', 'pre workout', 'bcaa', 'eaa',
    'amino', 'glutamine', 'collagen', 'vitamin', 'multivitamin', 'omega 3', 'fish oil', 'zinc', 'magnesium', 'casein',
    'testosterone', 'citrulline', 'beta alanine', 'electrolytes', 'optimum nutrition', 'muscletech', 'applied nutrition',
    'dymatize', 'rule 1', 'basix', 'biotechusa', 'nutrex', 'kevin levrone', 'bpi sports', 'cellucor', 'c4', 'quamtrax',
    'nutrend', 'challenger', 'labrada', 'olimp', 'redcon1', 'scivation', 'xtend', 'mutant', 'myprotein', 'allmax',
    'nitro tech', 'gold standard', 'iso100', 'lipo 6', 'anabol', 'mega amino'
  ];

  function norm(s) {
    return String(s || '')
      .toLowerCase()
      .replace(/[ً-ْـ]/g, '') // Arabic diacritics and tatweel
      .replace(/[أإآ]/g, 'ا')
      .replace(/ى/g, 'ي')
      .replace(/ة/g, 'ه')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function lookup(n) {
    if (Object.prototype.hasOwnProperty.call(ALIASES, n)) return ALIASES[n];
    // Arabic definite article: "البروتين" -> "بروتين"
    if (/^ال[؀-ۿ]{3,}$/.test(n)) {
      var bare = n.slice(2);
      if (Object.prototype.hasOwnProperty.call(ALIASES, bare)) return ALIASES[bare];
    }
    return null;
  }

  // Returns { q: term to search, changed: bool }.
  function rewrite(q) {
    var n = norm(q);
    if (!n) return { q: q, changed: false };
    var whole = lookup(n);
    if (whole) return { q: whole, changed: true };
    // Word by word, skipping very short words ("on", "pre") that are only
    // safe to map when they are the whole query.
    var changed = false;
    var out = n.split(' ').map(function (w) {
      if (w.length < 3 || w === 'pre') return w;
      var hit = lookup(w);
      if (hit) {
        changed = true;
        return hit;
      }
      return w;
    });
    return changed ? { q: out.join(' '), changed: true } : { q: q, changed: false };
  }

  function distance(a, b) {
    if (a === b) return 0;
    var prev = [], cur = [], i, j;
    for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++) {
      cur = [i];
      for (j = 1; j <= b.length; j++) {
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
      }
      prev = cur;
    }
    return prev[b.length];
  }

  function didYouMean(q) {
    var n = norm(q);
    if (!n) return [];
    var picks = [];
    var r = rewrite(n);
    if (r.changed) picks.push(r.q);
    var limit = Math.max(1, Math.floor(n.length / 4));
    VOCAB.map(function (w) {
      return { w: w, d: distance(n, w) };
    })
      .filter(function (x) {
        return x.d > 0 && x.d <= limit;
      })
      .sort(function (a, b) {
        return a.d - b.d;
      })
      .forEach(function (x) {
        if (picks.indexOf(x.w) === -1) picks.push(x.w);
      });
    return picks.slice(0, 3);
  }

  function searchUrl(term, extra) {
    var root = (window.routes && window.routes.search_url) || '/search';
    var p = new URLSearchParams();
    p.set('q', term);
    p.set('type', 'product');
    p.set('options[prefix]', 'last');
    p.set('options[unavailable_products]', 'last');
    if (extra) Object.keys(extra).forEach(function (k) { p.set(k, extra[k]); });
    return root + '?' + p.toString();
  }

  function fillDidYouMean(el, q) {
    if (!el) return;
    var picks = didYouMean(q);
    if (!picks.length) return;
    el.textContent = '';
    var label = document.createElement('span');
    label.className = 'tms-dym__label';
    label.textContent = 'Did you mean: ';
    el.appendChild(label);
    picks.forEach(function (w, i) {
      var a = document.createElement('a');
      a.href = searchUrl(w, { oq: q });
      a.textContent = w;
      a.className = 'tms-dym__link';
      el.appendChild(a);
      if (i < picks.length - 1) el.appendChild(document.createTextNode(', '));
    });
    el.hidden = false;
  }

  // Any search form: search the corrected term, keep the original as `oq`.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (e.defaultPrevented || !form || form.getAttribute('role') !== 'search') return;
    var input = form.querySelector('input[name="q"]');
    if (!input || !input.value.trim()) return;
    var r = rewrite(input.value);
    if (!r.changed || norm(r.q) === norm(input.value)) return;
    var original = input.value.trim();
    input.value = r.q;
    var oq = form.querySelector('input[name="oq"]');
    if (!oq) {
      oq = document.createElement('input');
      oq.type = 'hidden';
      oq.name = 'oq';
      form.appendChild(oq);
    }
    oq.value = original;
  });

  function initSearchPage() {
    var params = new URLSearchParams(window.location.search);
    var q = params.get('q') || '';
    var oq = params.get('oq');
    var empty = document.querySelector('[data-tms-search-empty]');

    // Came in by link (no oq) and nothing matched: retry once with the fix.
    if (empty && q && !oq && !params.get('tms_exact')) {
      var r = rewrite(q);
      if (r.changed && norm(r.q) !== norm(q)) {
        window.location.replace(searchUrl(r.q, { oq: q.trim() }));
        return;
      }
    }

    var note = document.querySelector('[data-tms-search-note]');
    if (note && oq && norm(oq) !== norm(q)) {
      note.textContent = '';
      note.appendChild(document.createTextNode('Showing results for '));
      var b = document.createElement('strong');
      b.textContent = q;
      note.appendChild(b);
      note.appendChild(document.createTextNode('. Search instead for '));
      var a = document.createElement('a');
      a.href = searchUrl(oq, { tms_exact: '1' });
      a.textContent = oq;
      note.appendChild(a);
      note.hidden = false;
    }

    if (empty) fillDidYouMean(empty.querySelector('[data-tms-did-you-mean]'), q);
  }

  window.TMSSearch = { norm: norm, rewrite: rewrite, didYouMean: didYouMean, fillDidYouMean: fillDidYouMean };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearchPage);
  } else {
    initSearchPage();
  }
})();
